export const Routes = {
  Auth: {
    Login: { url: '/login', path: 'login/*' },
    ForgotPassword: {
      url: '/login/forgot-password',
      path: '/forgot-password',
    },
    SetNewPassword: {
      url: '/login/set-new-password/:username',
      path: '/set-new-password/:username',
    },
  },
}
